import { FileTextIcon, ClipboardCheckIcon, VideoIcon } from "lucide-react";

interface RejectionIconProps {
    className?: string;
    variant?: "resume" | "assessment" | "interview" | string;
}

export default function RejectionIcon({ className, variant = "resume", ...props }: RejectionIconProps) {

    // Select the appropriate icon based on variant
    const renderIcon = () => {
        switch (variant) {
            case "resume":
                return <FileTextIcon className="h-6 sm:h-10 w-6 sm:w-10" />;

            case "assessment":
                return <ClipboardCheckIcon className="h-6 sm:h-10 w-6 sm:w-10" />;

            case "interview":
                return <VideoIcon className="h-6 sm:h-10 w-6 sm:w-10" />;

            case "interview-short":
                return <VideoIcon className="h-6 sm:h-10 w-6 sm:w-10" />;

            default:
                return <FileTextIcon className="h-6 sm:h-10 w-6 sm:w-10" />;
        }
    };

    return (
        <div
            className={`w-16 sm:w-20 h-16 sm:h-20 rounded-full flex items-center justify-center ${variant === "interview-short" ? "bg-yellow-100 text-yellow-700" : "bg-red-100 text-red-700"} ${className}`}
            {...props}
        >
            {renderIcon()}
        </div>
    );
}
